import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "./config";
import { loginWithSocial } from "../redux/zservices/BasicAPIFunctions";

const SOCIAL_FROM = {
  google: 2,
  facebook: 3,
  linkedin: Number(process.env.REACT_APP_LINKEDIN_SOCIAL_FROM || 4),
};

const LINKEDIN_PROVIDER_ID =
  process.env.REACT_APP_LINKEDIN_PROVIDER_ID || "oidc.linkedin";

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const linkedInProvider = new OAuthProvider(LINKEDIN_PROVIDER_ID);

googleProvider.addScope("email");
googleProvider.addScope("profile");
facebookProvider.addScope("email");
linkedInProvider.addScope("openid");
linkedInProvider.addScope("email");
linkedInProvider.addScope("profile");

const getNameParts = (displayName = "") => {
  const [firstName = "", ...lastNameParts] = displayName.trim().split(" ");

  return {
    first_name: firstName,
    last_name: lastNameParts.join(" "),
  };
};

const getCredentialToken = (credential) =>
  credential?.idToken || credential?.accessToken || "";

const buildSocialPayload = ({ result, credential, socialFrom }) => ({
  social_from: socialFrom,
  social_id: result.user.uid,
  social_token: getCredentialToken(credential),
});

const buildSignupDetails = ({ result, socialPayload }) => ({
  ...getNameParts(result.user.displayName),
  email_id: result.user.email || "",
  image: result.user.photoURL || null,
  ...socialPayload,
});

const signInWithProvider = async ({
  provider,
  socialFrom,
  getCredentialFromResult,
  providerName,
}) => {
  try {
    const result = await signInWithPopup(auth, provider);
    const credential = getCredentialFromResult(result);
    const socialPayload = buildSocialPayload({
      result,
      credential,
      socialFrom,
    });

    const loginRes = await loginWithSocial(socialPayload);

    return {
      loginRes,
      userdetailsforsignup: buildSignupDetails({
        result,
        socialPayload,
      }),
    };
  } catch (error) {
    console.error(`${providerName} Login Error:`, error);
    throw error;
  }
};

export const signInWithGoogle = () =>
  signInWithProvider({
    provider: googleProvider,
    socialFrom: SOCIAL_FROM.google,
    getCredentialFromResult: GoogleAuthProvider.credentialFromResult,
    providerName: "Google",
  });

export const signInWithFacebook = () =>
  signInWithProvider({
    provider: facebookProvider,
    socialFrom: SOCIAL_FROM.facebook,
    getCredentialFromResult: FacebookAuthProvider.credentialFromResult,
    providerName: "Facebook",
  });

export const signInWithLinkedIn = () =>
  signInWithProvider({
    provider: linkedInProvider,
    socialFrom: SOCIAL_FROM.linkedin,
    getCredentialFromResult: OAuthProvider.credentialFromResult,
    providerName: "LinkedIn",
  });
